import { jsx as _jsx } from "react/jsx-runtime";
import { RadiobuttonIcon } from "@radix-ui/react-icons";
import { iconSize } from "../../../../../../core/design-system/index.js";
import { CADIcon } from "../../../icons/currencies/CADIcon.js";
import { EURIcon } from "../../../icons/currencies/EURIcon.js";
import { GBPIcon } from "../../../icons/currencies/GBPIcon.js";
import { JPYIcon } from "../../../icons/currencies/JPYIcon.js";
import { USDIcon } from "../../../icons/currencies/USDIcon.js";
export const usdCurrency = {
    shorthand: "USD",
    countryCode: "US",
    name: "US Dollar",
    symbol: "$",
    icon: USDIcon,
};
export const currencies = [
    usdCurrency,
    {
        shorthand: "CAD",
        countryCode: "CA",
        name: "Canadian Dollar",
        symbol: "$",
        icon: CADIcon,
    },
    {
        shorthand: "GBP",
        countryCode: "GB",
        name: "British Pound",
        symbol: "£",
        icon: GBPIcon,
    },
    {
        shorthand: "EUR",
        countryCode: "EU",
        name: "Euro",
        symbol: "€",
        icon: EURIcon,
    },
    {
        shorthand: "JPY",
        countryCode: "JP",
        name: "Japanese Yen",
        symbol: "¥",
        icon: JPYIcon,
    },
    {
        shorthand: "AUD",
        countryCode: "AU",
        name: "Australian Dollar",
        symbol: "$",
    },
    {
        shorthand: "NZD",
        countryCode: "NZ",
        name: "New Zealand Dollar",
        symbol: "$",
    },
];
export function getCurrencyMeta(shorthand) {
    return (currencies.find((currency) => currency.shorthand.toLowerCase() === shorthand.toLowerCase()) ?? {
        // This should never happen
        icon: UnknownCurrencyIcon,
        countryCode: "US",
        name: shorthand,
        symbol: "$",
        shorthand: shorthand,
    });
}
export function getFiatIcon(currency, size) {
    return currency.icon ? (_jsx(currency.icon, { size: iconSize[size] })) : (_jsx("img", { src: `https://flagsapi.com/${currency.countryCode.toUpperCase()}/flat/64.png`, alt: currency.shorthand, width: iconSize[size], height: iconSize[size] }));
}
const UnknownCurrencyIcon = (props) => {
    return _jsx(RadiobuttonIcon, { width: props.size, height: props.size });
};
//# sourceMappingURL=currencies.js.map